import { OpenDesignState, SET_SHOW_OPEN_DESIGN, SET_OPEN_DESIGN_INPUT } from './types';
import { Actions } from '..';

const initialState: OpenDesignState = {
	showOpenDesign: false,
	openDesignInput: '',
};

export function openDesignReducer(state = initialState, action: Actions): OpenDesignState {
	switch (action.type) {
		case SET_SHOW_OPEN_DESIGN: {
			return { ...state, showOpenDesign: action.value, openDesignInput: '' };
		}
		case SET_OPEN_DESIGN_INPUT: {
			return { ...state, openDesignInput: action.value };
		}
		default:
			return state;
	}
}
